module.exports = __webpack_public_path__ + "fonts/DINPro-Bold.ab2b74fd.woff";